import * as yup from "yup";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IoSaveOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";

import ReactSelectAsync from "../../../components/common/ReactSelectAsync";
import Toaster from "../../../components/common/Toaster";
import accountService from "../../../services/accountService";
import employeeService from "../../../services/employeeService";

const schema = yup.object({
  support: yup.object().shape({
    label: yup.string().required("Please select support designation."),
    value: yup.string().required("Please select support designation."),
  }),
});

const SupportForm = ({ data, setData, isLoading, setLoading, onSuccess }) => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (info) => {
    try {
      const support_id = info.support.value;
      const support_name = info.support.label;

      const account = { ...data, support_id, support_name };
      setData(account);

      await accountService.saveAccountSupportAsync(data.id, support_id);

      Toaster.Success("Support Updated Successfully");
      setLoading(false);
      onSuccess();
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    }
  };

  useEffect(() => {
    if (data.support_id) {
      const selected_support = {
        label: data.support_name,
        value: data.support_id,
      };

      setValue("support", selected_support);
    }
  }, [data, setValue]);

  const options = async (search, loadedOptions, { page }) => {
    const params = {
      search_query: search,
      current_page: page,
      page_size: 10,
      sort_column: { path: "created_on", order: "desc" },
    };

    const response = await employeeService.getEmployeesAsync(params);
    const { result: data, count, total_count } = response;

    const options = data.map((item) => {
      return {
        label: item.first_name + " " + item.last_name,
        value: item.user_id,
      };
    });

    const hasMore = total_count > count;

    return {
      options,
      hasMore,
      additional: {
        page: page + 1,
      },
    };
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelectAsync
            id="support-dropdown"
            name="support"
            title="Support"
            options={options}
            control={control}
            register={register("support")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-2 pt-2">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSaveOutline className="mr-3" />}
            Save Changes
          </button>
        </div>
      </div>
    </form>
  );
};

export default SupportForm;
